module.exports = __webpack_public_path__ + "static/img/reuseContent.114c54ac.png";